import { LIMPAR_PRECOS } from '../types'

export default function limparPrecos () {
  return {
    type: LIMPAR_PRECOS,
  }
}
